<template>
  <div>
    <h1 class="page-header">{{ $t('transportationway.transportationway') }}</h1>
    <div class="row">
      <div class="col-lg-3 col-md-3 col-sm-12">
        <ts-card>
          <ts-card-wrapper>
            <div class="form-group m-b-15">
              <label class="required">{{
                $t('transportationway.transportationNumber')
              }}</label>
              <input
                v-model.number="model.way_no"
                type="number"
                class="form-control"
                :class="{ 'is-invalid': errors.has('way_no') }"
                :placeholder="$t('transportationway.entertransportationnumber')"
              />
              <div class="invalid-feedback" v-if="errors.has('way_no')">
                {{ errors.first('way_no') }}
              </div>
            </div>
            <div class="form-group">
              <label>{{ $t('transportationway.description') }}</label>
              <textarea
                v-model="model.way_description"
                class="form-control"
                :class="{ 'is-invalid': errors.has('way_description') }"
                :placeholder="$t('transportationway.description')"
              ></textarea>
              <div
                class="invalid-feedback"
                v-if="errors.has('way_description')"
              >
                {{ errors.first('way_description') }}
              </div>
            </div>
            <div class="text-right">
              <ts-button v-if="updating" class="mr-2" @click.prevent="cancel">
                {{ $t('cancel') }}
              </ts-button>
              <ts-button
                v-if="updating"
                class="btn-primary"
                :waiting="waiting"
                @click.prevent="update"
              >
                {{ $t('update') }}
              </ts-button>
              <ts-button
                v-if="!updating"
                :waiting="waiting"
                class="btn-primary"
                @click.prevent="store"
                >{{ $t('save') }}</ts-button
              >
            </div>
          </ts-card-wrapper>
        </ts-card>
      </div>
      <div class="col-lg-9 col-md-9 col-sm-12">
        <data-table :fetch="fetch" @fetched="fetch = false"></data-table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import DataTable from './table'
import { Errors } from 'form-backend-validation'

export default {
  name: 'transportation-way-form',
  components: {
    DataTable
  },
  data() {
    return {
      model: {
        way_id: '',
        way_no: '',
        way_description: ''
      },
      errors: new Errors(),
      waiting: false,
      fetch: false,
      updating: false
    }
  },
  created() {
    this.setEditData()
  },
  computed: {
    ...mapState('transportationWay', ['edit_data'])
  },
  methods: {
    store() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('transportationWay/store', this.model)
        .then(response => {
          this.clearInput()
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },
    update() {
      this.errors = new Errors()
      this.waiting = true
      this.$store
        .dispatch('transportationWay/update', this.model)
        .then(response => {
          this.$toasted.success(response.message)
          this.waiting = false
          this.fetch = true
          this.cancel()
        })
        .catch(error => {
          this.errors = new Errors(error.errors)
          this.$toasted.error(error.message)
          this.waiting = false
        })
    },

    cancel() {
      this.updating = false
      this.$store.commit('transportationWay/SET_EDIT_DATA', {})
      this.$router.push({ name: 'way-transportation' })
      this.clearInput()
    },
    clickBackURL() {
      this.$store.commit('transportationWay/SET_EDIT_DATA', {})
      this.clearInput()
      this.fetch = true
      this.updating = false
    },
    setEditData() {
      if (!_.isEmpty(this.edit_data)) {
        this.errors = new Errors()
        this.model = _.clone(this.edit_data)
        this.updating = true
      }
    },
    clearInput() {
      this.model = {
        way_id: '',
        way_no: '',
        way_description: ''
      }
    }
  },
  watch: {
    edit_data: {
      handler() {
        this.setEditData()
      }
    }
  },
  beforeRouteLeave(to, from, next) {
    if (_.isEmpty(to.params)) {
      this.$store.commit('transportationWay/RESET_STATE')
      this.clickBackURL()
    }
    next()
  }
}
</script>
